import { gql } from '@apollo/client';

export const TASK_PROGRESS_QUERY = gql`
  query GetTask($taskId: ID!) {
    task(id: $taskId) {
      id
      task_progress {
        id
        content
        progress
        end_date
        created_by
        updated_by
        created_at
        updated_at
        attachments {
          id
          data_file_name
          url
        }
      }
    }
  }
`;

export const CREATE_OR_UPDATE_TASK_PROGRESS = gql`
  mutation CreateOrUpdateTaskProgress($id: ID, $task_id: Int, $content: String, $progress: Int, $end_date: String) {
    createOrUpdateTaskProgress(id: $id, task_id: $task_id, content: $content, progress: $progress, end_date: $end_date) {
      task_progress {
        id
        content
        progress
        end_date
        created_at
      }
      errors
    }
  }
`;

export const DELETE_TASK_PROGRESS = gql`
  mutation DeleteTaskProgress($id: ID!) {
    destroyTaskProgress(id: $id) {
      success
    }
  }
`;
